module.exports = __webpack_public_path__ + "static/media/TenantBuyer2.15d98f85.jpg";